<rid-focus-reading
  class="h-dvh"
  [sentencess]="[
    ['Er was eens een man met een plan.', 'Hij wilde vliegen.', 'Dus bouwde hij een vliegtuig.'],
    ['Er was eens een man met een plan.', 'Hij wilde vliegen.'],
  ]"
  [pace]="pace()"
  (finished)="$router.navigate(['/mechanics/reading-basis'])"
/>
